import { useEffect, useState } from 'react';
import { useWorkspaceNavigate as useNavigate } from '@/contexts/DocumentWorkspace';
import { supportApi } from '../lib/supportApi';

export default function Support() {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    supportApi.list()
      .then((d) => setTickets(d.tickets || []))
      .catch((e) => setError(e.message))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div style={{ maxWidth: 720, margin: '24px auto', padding: 16 }}>
      <h1 style={{ fontSize: 22 }}>Support</h1>
      <p style={{ color: '#666', fontSize: 14 }}>Your support conversations. Start a new one from the <a href="/contact">contact page</a>.</p>
      {loading && <p style={{ color: '#888' }}>Loading…</p>}
      {error && <p style={{ color: '#b91c1c' }}>{error}</p>}
      {!loading && !error && tickets.length === 0 && <p style={{ color: '#888' }}>No tickets yet.</p>}
      {tickets.map((tk) => (
        <button key={tk.id} onClick={() => navigate(`/account/support/${tk.id}`)}
          style={{ display: 'block', width: '100%', textAlign: 'left', padding: 14, margin: '8px 0', border: '1px solid #e5e7eb', borderRadius: 8, background: '#fff', cursor: 'pointer' }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', gap: 12 }}>
            <span style={{ fontWeight: 600 }}>{tk.subject}</span>
            <span style={{ fontSize: 12, color: '#666', textTransform: 'capitalize' }}>{tk.status}</span>
          </div>
          <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>Updated {new Date(tk.last_message_at).toLocaleString()}</div>
        </button>
      ))}
    </div>
  );
}
